import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "undo-toast toast show align-items-center text-bg-dark border-0",
  role: "status",
  "aria-live": "polite"
}
const _hoisted_2 = { class: "d-flex align-items-center" }
const _hoisted_3 = { class: "toast-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (_ctx.message !== null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.message), 1),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-sm btn-link text-warning fw-semibold me-2",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('undo')))
            }, " Vrátit zpět ")
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}